import { InfoCircleOutlined, WhatsAppOutlined } from '@ant-design/icons'
import FormCard from '@components/FormCard'
import Page from '@components/Page/Page'
import { useAppSelector } from '@store/hooks'
import { selectSelectedProgram } from '@store/membership/ProgramReducer'
import { SBRMAction } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { Col, Row } from 'antd'

const ConciergeTab = () => {
  const program = useAppSelector(selectSelectedProgram())

  if (!program) {
    return <></>
  }

  return (
    <Page>
      <Row gutter={[32, 32]}>
        <Col span={12}>
          <FormCard
            title="Informations"
            entity={Entity.membershipProgram}
            action={SBRMAction.Update}
            sections={['concierge']}
            icon={<InfoCircleOutlined />}
          />
        </Col>
        <Col span={12}>
          <FormCard
            title="Chat"
            entity={Entity.membershipProgram}
            action={SBRMAction.Update}
            sections={['whatsapp']}
            icon={<WhatsAppOutlined />}
          />
        </Col>
      </Row>
    </Page>
  )
}

export default ConciergeTab
